import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBugComponent } from "./med-icon-bug.component";

@NgModule({
  declarations: [
    MedIconBugComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBugComponent,
  ],
})
export class MedIconBugModule { }
